import React from "react";
import { Search } from "lucide-react";

export type ClientRequestFilterValues = {
  q: string;
  type: string;
  status: string;
};

export default function AdminClientRequestFilters(props: {
  value: ClientRequestFilterValues;
  onChange: (next: ClientRequestFilterValues) => void;
}): React.JSX.Element {
  const v = props.value;
  const field =
    "w-full rounded-lg border border-white/10 bg-slate-950 px-3 py-2 text-sm text-slate-100 outline-none transition placeholder:text-slate-500 focus:border-emerald-500/40 focus:ring-2 focus:ring-emerald-500/20";
  return (
    <div className="flex flex-wrap items-end gap-3 rounded-xl border border-white/10 bg-slate-900/50 p-4 shadow-inner shadow-black/20">
      <label className="flex min-w-[200px] flex-1 flex-col gap-1 text-xs font-medium text-slate-400">
        Recherche
        <span className="relative">
          <Search className="pointer-events-none absolute left-3 top-2.5 h-4 w-4 text-slate-500" aria-hidden />
          <input
            type="search"
            value={v.q}
            onChange={(e) => props.onChange({ ...v, q: e.target.value })}
            placeholder="Référence, client, motif…"
            className={`${field} pl-9`}
          />
        </span>
      </label>
      <label className="flex min-w-[140px] flex-col gap-1 text-xs font-medium text-slate-400">
        Type
        <select value={v.type} onChange={(e) => props.onChange({ ...v, type: e.target.value })} className={field}>
          <option value="">Tous</option>
          <option value="PASSAGE_CHANGE">Changement passage</option>
          <option value="URGENT_INTERVENTION">Urgence</option>
          <option value="SERVICE_QUALITY">Qualité</option>
          <option value="BILLING">Facturation</option>
        </select>
      </label>
      <label className="flex min-w-[140px] flex-col gap-1 text-xs font-medium text-slate-400">
        Statut
        <select value={v.status} onChange={(e) => props.onChange({ ...v, status: e.target.value })} className={field}>
          <option value="">Tous</option>
          <option value="PENDING">En attente</option>
          <option value="UNDER_REVIEW">En analyse</option>
          <option value="RESOLVED">Résolue</option>
          <option value="REJECTED">Rejetée</option>
          <option value="OPEN">Ouverte</option>
        </select>
      </label>
    </div>
  );
}
